import Device from './device';

const img = require('../../assets/images/suunto-movescount.png');

export default class Suunto extends Device {
  constructor(...params) {
    super(...params);

    this.loadedImage = img;
  }

  get type() {          // eslint-disable-line
    return 'suunto';
  }

  get manufacturer() {  // eslint-disable-line
    return 'Suunto';
  }

  get authToken() {
    return this.store.getters.loggedInMember.suuntoLinked;
  }

  get isLinked() {
    return this.authToken;
  }

  get linkUrl() {
    return `${super.linkUrl}/suunto/request?cognito_username=${this.store.state.member.loggedInMember.awsCognitoSub}`;
  }

  unlink() {
    return this.dao.httpGet('oauth1/suunto/unlink');
  }
}
